import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const bayPinesConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Bay Pines Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Bay Pines, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_bay_pines',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Bay Pines',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Bay Pines Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the residential and waterfront 
     properties of <strong>Bay Pines</strong> with expert tree care built for 
     Pinellas County's coastal environment. Sitting alongside the Intracoastal 
     Waterway and Boca Ciega Bay, properties here experience tidal winds and storm 
     exposure that stress trees over time. Overgrown canopies, weakened trunks, 
     and storm split limbs near homes and docks all require experienced, professional 
     handling and that's exactly what we deliver.`,

    `We specialize in <strong>hazardous tree removal and precision trimming</strong>
     including large limb removal near waterfront structures, palms leaning toward 
     seawalls or homes, storm compromised canopies that need reduction before 
     hurricane season, and full tree takedowns where trees have become too 
     dangerous to leave in place. We work carefully and clean up completely.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Bay Pines</strong> and the surrounding 
     <strong>South Pinellas waterfront</strong> communities keeping your 
     property protected and your landscape healthy all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Bay Pines, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_BayPines = () => <LocationPage config={bayPinesConfig} />;
export default Services_BayPines;
